import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { apiClient } from '../lib/api';
import { Admin } from '../types';
import { UserIcon } from '@heroicons/react/24/outline';

const OnlineStatus: React.FC = () => {
  const { data: onlineAdmins } = useQuery(
    ['online-admins'],
    () => apiClient.getOnlineAdmins(),
    {
      refetchInterval: 30000, // Обновляем каждые 30 секунд
    }
  );

  // Обновляем статус онлайн при загрузке компонента
  useEffect(() => {
    const updateStatus = async () => {
      try {
        await apiClient.updateOnlineStatus();
      } catch (error) {
        console.error('Failed to update online status:', error);
      }
    };

    updateStatus();

    // Обновляем статус каждые 2 минуты
    const interval = setInterval(updateStatus, 120000);

    // Очищаем интервал при размонтировании
    return () => {
      clearInterval(interval);
      // Устанавливаем статус оффлайн при закрытии
      apiClient.setOfflineStatus().catch(console.error);
    };
  }, []);

  const admins = onlineAdmins?.data || [];

  if (admins.length === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 bg-white rounded-lg shadow-lg p-4 border border-gray-200 z-40">
      <div className="flex items-center space-x-2 mb-2">
        <UserIcon className="h-4 w-4 text-green-500" />
        <span className="text-sm font-medium text-gray-700">
          Онлайн ({admins.length})
        </span>
      </div>
      <div className="space-y-1">
        {admins.map((admin) => (
          <div key={admin.id} className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            <span className="text-xs text-gray-600">{admin.username}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OnlineStatus; 